<template>
  <div>
    <div class="container" >
      <qr-text-field-ordem ref="ordem"
        key="ordem"
        class="textfield n-center order-input"
        label="Nro O.C."
        hide-details
        icon="mdi-qrcode-scan"
        v-model="search"
        :action="() => $_onClickQR('qrordem')"
        modulo="ordem"
      />

      <v-progress-circular v-if="$$_loading"
        indeterminate
        size="40"
        color="grey"
        class="d-block mx-auto my-4"
      ></v-progress-circular>
    
      <v-card class="card" v-if="Object.values($$_ordem).length > 0 && !$$_loading && !$$_ordem.orcdatafinalizado && !$$_ordem.orcdatafaturamento"
        @click="$$_ordem.orcdatainicio ? $_abrirOrdem($$_ordem.orcidordemcarregamento) : $_abrirOrdem($$_ordem.orcidordemcarregamento, true)"
      >
        <div class="card_title">
          <!-- <v-card-title  class="card_title mx-auto">29/09/2025 11:00</v-card-title>   -->
          <b class="">O.C : {{$$_ordem?.orcidordemcarregamento}}</b>  
          <b class="">{{$_FormataDataGeral($$_ordem?.orcdataordem)}}</b>  
        </div>
        <v-icon size="100" color="black">mdi-truck-cargo-container</v-icon>
        <div class="card_detalhes">
          <span v-if="$$_ordem?.orctipomercado" class="d-block px-1"><b>Tipo de Mercado</b><span>: {{$$_ordem.orctipomercado}}</span></span>

          <v-divider></v-divider>
          <span class="d-flex justify-space-between" :style="{maxHeight: '24px'}">
          <p v-if="$$_ordem.orcplaca" class="pl-1 pr-2"><b>Placa</b>: {{$$_ordem.orcplaca}}</p>
          <b :style="{fontSize: '27px', alignSelf: 'center'}">-</b>
          <p v-if="$$_ordem.orcplacacomplementar1" class="px-2"> {{$$_ordem.orcplacacomplementar1}}</p>
          <b :style="{fontSize: '27px', alignSelf: 'center'}">-</b>
          <p v-if="$$_ordem.orcplacacomplementar2" class="px-2"> {{$$_ordem.orcplacacomplementar2}}</p>
          </span>
          <span v-if="$$_ordem.orcmarca" class="d-block px-1"><b>Veículo</b>: {{$$_ordem.orcmarca}}</span>
          
          <v-divider></v-divider>
          <span v-if="$$_ordem.orcmotorista" class="d-block px-1"><b>Motorista</b>: {{$$_ordem.orcmotorista}}</span>

          <v-divider></v-divider>
          <span v-if="$$_ordem.orctransportador" class="d-block px-1"><b>Transportador</b>: {{$$_ordem.orctransportador}}</span>

          <v-divider></v-divider>
          <span v-if="$$_ordem?.orcdoca" class="d-block px-1"><b>Doca</b>: {{$$_ordem.orcdoca}} - {{$$_ordem.orcarmazem}}</span>

          <v-divider></v-divider>
          <span v-if="$$_ordem?.orcobservacao" class="d-block px-1"><b>Observação</b>: {{$$_ordem.orcobservacao}}</span>

          <v-divider></v-divider>
          <span v-if="$$_ordem?.orcdatainicio" class="d-block px-1"><b>Data Início</b>: {{$_FormataDataGeral($$_ordem?.orcdatainicio)}}</span>
          

        </div>
      </v-card>
      <div v-if="!$_isEmpty($$_ordem) && !$$_loading" class="botoes">
        <v-btn  color="primary" :disabled="!!$$_ordem.orcdatainicio" @click="$_iniciarCarregamento($$_ordem)">
            Iniciar
        </v-btn>
        <v-btn  color="#607d8b"  @click="$_onClickCamera()">
            <v-icon color="white" size="35">mdi-camera</v-icon>
        </v-btn>
        <v-btn  color="primary" :disabled="!$$_ordemFinalizar || enviando"  @click="$_abrirFinalizar">
            Finalizar
        </v-btn>
      </div>

      <v-dialog v-model="dialogFinalizar" @click:outside="$_clearHashRoute()" max-width="500px" >
        <v-card>
            <v-card-title class="headline primary white--text text-h5 px-6">Confirmar Finalização</v-card-title>
            <v-card-text class="text-subtitle-1 mt-5">
                Tem certeza que deseja finalizar esta Ordem de Carregamento?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogFinalizar = false, $_clearHashRoute()" :disabled="enviando">
                    Cancelar
                </v-btn>
                <v-btn color="primary" text @click="$_confirmarFinalizacao" :loading="enviando">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogInicio" @click:outside="$_clearHashRoute()" max-width="500px" >
        <v-card>
            <v-card-title class="headline primary white--text text-h5 px-6">Iniciar Carregamento</v-card-title>
            <v-card-text v-if="$$_ordem.orcdoca" class="text-subtitle-1 mt-2">
                Faça a leitura da Doca do Carregamento:
              <qr-text-field-ordem ref="doca"
                class="textfield n-center order-input mt-5"
                :style="{width: '100%'}"
                key="doca"
                label="Doca"
                icon="mdi-qrcode-scan"
                v-model="doca"
                clearable
                :action="() => $_onClickQR('qrdoca')"
                modulo="doca"
                :error="$$_validacaoDoca"
                :error-messages="$$_validacaoDoca ? 'Doca incorreta para o carregamento.' : ''"
              />
            </v-card-text>
            <v-card-text v-else class="text-subtitle-1 mt-2">
              Deseja realmente iniciar o carregamento?
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">

                <v-btn text @click="$_voltarInicio()" >
                    Voltar
                </v-btn>
                <v-btn color="primary" text @click="$_iniciarCarregamento($$_ordem)" >
                    Iniciar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <validation-dialog
        v-model="validacaoFinalizar"
        :tipo="validacaoTipo"
        :validacaoData="validacaoData"
        @validacaoContinuar="$_continuarFinalizar"
      />

      <v-dialog v-model="dialogVisivel" @click:outside="$_clearHashRoute()" width="700px" scrollable>
      <v-card class="card-all" v-if="itemSelecionado">
        <v-card-title class="headline primary white--text text-h6 px-1">
          <v-icon color="white" size="25" class="pr-5" @click="dialogVisivel = false, $_clearHashRoute()">mdi-arrow-left</v-icon>
          <strong class="cardtitle"> Produtos a Serem Carregados </strong>
            <!-- <strong v-if="itemSelecionado.orcobservacao" class="cardtitle ml-1">-  {{itemSelecionado.orcobservacao}}</strong> -->
        </v-card-title>
        <v-progress-linear indeterminate color="primary" v-if="loadingItens"></v-progress-linear>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-radio-group v-model="selectedItemId" mandatory hide-details class="ma-0 pa-0">
            <div v-if="!loadingItens && !$$_itens.length" class="text-center grey--text py-8">
              Nenhum item encontrado.
            </div>
            <simplebar
              v-if="$$_itens.length > 0"
              data-simplebar
              :autoHide="false"
              :options="{ scrollLock: true }"
              class="table-scroll-container-card"
            >
              <table class="table-custom">
                <colgroup>
                  <col style="width: 40px;"> <col style="width: 80px;"> <col style="width: 290px;"> <col style="width: 80px;"> <col style="width: 80px;"> <col style="width: 125px;"> <col style="width: 125px;"> </colgroup>
                <thead class="table-header-card">
                  <tr>
                    <th></th>
                    <th>Código</th>
                    <th class="text-center coluna-descricao">Produto</th>
                    <th class="text-start">Quantidade</th>
                    <th class="text-start pl-4">Cliente</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in $$_itens" :key="item.ociidordemcarregamentoitem" class="table-row" 
                  @click="selectedItemId = item.ociidordemcarregamentoitem" 
                  :class="{ 'dark-background': index % 2 !== 0 && item.ociidordemcarregamentoitem !== selectedItemId, 
                  'linha-selecionada': item.ociidordemcarregamentoitem === selectedItemId,
                  'linha-finalizada': item.ocidatafinalizado }">
                    <td><v-radio :value="item.ociidordemcarregamentoitem" class="ma-0 pa-0"></v-radio></td>
                    <td class="text-right">{{ item.ociprodutocodigo }}</td>
                    <td class="text-center coluna-descricao">{{ item.ociproduto }}</td>
                    <td class="text-right">{{ FormataQuantVirgula(item.ociquantidade) }}</td>
                    <td class="text-right coluna-descricao">{{ $_limitarTexto(item.ocicliente, 40) }}</td>

                  </tr>
                </tbody>
              </table>
            </simplebar>
          </v-radio-group>
        </v-card-text>
        <v-divider class="mt-2"></v-divider>

        <v-card-actions class="pa-3 mx-auto">
          <v-btn :disabled="!$$_ordem.orcdatainicio" color="primary" elevation="2" @click="$_clearHashRoute(), $_abrirUnidade(selectedItemId)" >Ir para unidade</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </div>
</template>

<script>

// import errorHandler from '@/utils/error-handler';

import deepEquals from '@/utils/deep-equals';

import { getQueryValue } from '@/services/query-string';

import { ABASTECIMENTO_QUERIES } from '@/constants/QUERY_FILTERS';

import { ROUTE_CAMERA, ROUTE_QR, ROUTE_ORDEM_CARREGAMENTO, ROUTE_ORDEM_CARREGAMENTO_UNIDADE } from '@/constants/ROUTES';

import { CADLOTE_STORAGE, OPLOCAL_STORAGE, USER_STORAGE } from '@/constants/STORAGE';
import QrTextFieldOrdem from '@/components/core/qr-text-field-ordem/Index.vue'
import db from '@/plugins/dexie';

// import AppCardAtividadeSkeleton from '../../components/app/card/atividade/Skeleton.vue';
import moment from 'moment-timezone';
import { mapActions, mapMutations, mapState } from 'vuex';
import errorHandler from '@/utils/error-handler';

import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import geraData from '@/utils/geradata';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

import ValidationDialog from '@/components/app/dialog/ValidationDialog.vue';

export default {
  name: 'ViewFrota',

  components: {
    // CardAutoComplete,
    simplebar,
    QrTextFieldOrdem,
    ValidationDialog,
  },

  data() {
    return {
      loading: true,
      ordemsearch: {},
      ordens: [],
      search: null,
      enviando: false,
      dialogFinalizar: false,
      validacaoFinalizar: false,
      validacaoData: [],
      validacaoTipo: null,
      
      dialogVisivel: false,
      itemSelecionado: null,
      selectedItemId: null,
      reexibirDialog: false,
      loadingItens: false,
      itens: [],

      dialogInicio: false,

      doca: null,
      iddoca: null,
      leituraDoca: false,
      validarDoca: false,

      src: "/img/et.jpg",

      filters: {
        createdFrom: getSessionStorage(CADLOTE_STORAGE.createFrom, null),
        createdBefore: getSessionStorage(CADLOTE_STORAGE.createBefore, null),
      },
    };
  },

  computed: {
    $$_validacaoDoca() {
      return !!this.doca && this.doca.toUpperCase() !== this.$$_ordem.orcdoca.toUpperCase();
    },
    ...mapState({
      $$_ordem: (state) => state.ordemcarregamento.ordem,
      $$_itens: (state) =>  {
        const arr = Array.isArray(state.ordemcarregamento.itens);
        return arr ? state.ordemcarregamento.itens.sort((a, b) => a.ociidordemcarregamentoitem - b.ociidordemcarregamentoitem) : [];
      },
      itemAtual: (state) => state.ordemcarregamento.itemAtual,
      $$_cacheLote: (state) => state.cache.cache_aberturalote,
      $$_cacheApontamento: (state) => state.cache.cache_apontamentoproducao,
      $$_cacheOrdem: (state) => state.cache.cache_ordemcarregamento,
      $$_cacheItem: (state) => state.cache.cache_ordemcarregamentoitem,
      $$_cacheUnidade: (state) => state.cache.cache_ordemcarregamentounidade,
      $$_cacheLocal: (state) => state.cache.cache_localarmazenamento,
      $$_loading: (state) => state.ordemcarregamento.loading,
      $$_ordemFinalizar: (state) => state.ordemcarregamento.ordemFinalizar,
    })
  },

  methods: {
    ...mapMutations({
      $_adicionarItens: 'ordemcarregamento/SET_ITENS',
      $_adicionarItemAtual: 'ordemcarregamento/SET_ITEM_ATUAL',
      $_adicionarCache: 'cache/SET_CACHE',
      $_adicionarUnidades: 'ordemcarregamento/SET_UNIDADES',
      $_adicionarUnidadesInseridas : 'ordemcarregamento/SET_UNIDADES_INSERIDAS',
      
      $_limparItens: 'ordemcarregamento/CLEAR_ITENS',
      $_limparOrdem: 'ordemcarregamento/CLEAR_ORDEM',
      $_limparUnidades: 'ordemcarregamento/CLEAR_UNIDADES',
      $_limparItemAtual: 'ordemcarregamento/CLEAR_ITEM_ATUAL',
      $_limparUnidadesInseridas: 'ordemcarregamento/CLEAR_UNIDADES_INSERIDAS',

      $_setarOrdem: 'ordemcarregamento/SET_ORDEM',
    }),

    ...mapActions({
      $_getCache: 'cache/getCache',
      $_verificaCompleto: 'ordemcarregamento/verificaCompleto',
      $_reloadCache: 'cache/reloadCache',
      $_verificaUnidades: 'ordemcarregamento/verificaUnidades',
      $_verificaQuantidade: 'ordemcarregamento/verificaQuantidade'
    }),

    async $_load() {
      // this.loading = true;
      console.log(this.$$_ordem[0]);
      try {
        const ablcache = await this.$_getCache('aberturalote');
        const appcache = await this.$_getCache('apontamentoproducao');
        const lmecache = await this.$_getCache('localarmazenamento');
        const orccache = await this.$_getCache('ordemcarregamento');
        const ocicache = await this.$_getCache('ordemcarregamentoitem');
        const ocucache = await this.$_getCache('ordemcarregamentounidade');

        // this.$nextTick(async () => {

        if (!ablcache) {
          this.$_adicionarCache({tabela: 'aberturalote', dados: await db.aberturalote.orderBy('ablnrocontrole').toArray()});
        } else {
          // console.log('AberturaLote CACHED');
        }

        if (!appcache) {
          this.$_adicionarCache({tabela: 'apontamentoproducao', dados: await db.apontamentoproducao.toArray()});
        } else {
          // console.log('ApontamentoProducao CACHED');
        }

        if (!lmecache) {
          this.$_adicionarCache({tabela: 'localarmazenamento', dados:await db.localarmazenamento.toArray()});
        } else {
          // console.log('LocalArmazenamento CACHED');
        }

        if (!orccache) {
          this.$_adicionarCache({tabela: 'ordemcarregamento', dados:await db.ordemcarregamento.toArray()});
        } else {
          // console.log('OrdemCarregamento CACHED');
        }
        if (!orccache) {
          this.$_adicionarCache({tabela: 'ordemcarregamento', dados: await db.ordemcarregamento.toArray()});
        } else {
          // console.log('OrdemCarregamento CACHED');
        }

        if (!ocicache) {
          this.$_adicionarCache({tabela: 'ordemcarregamentoitem', dados: await db.ordemcarregamentoitem.toArray()});
        } else {
          // console.log('OrdemCarregamentoItem CACHED');
        }

        if (!ocucache) {
          this.$_adicionarCache({tabela: 'ordemcarregamentounidade', dados: await db.ordemcarregamentounidade.toArray()});
        } else {
          // console.log('OrdemCarregamentoUnidade CACHED');
        }

      // })
      } catch (err) {
        console.log(err);
      }
    },

    async $_iniciarCarregamento(ordem) {
      if (this.dialogInicio) {
        console.log('thisidoca', this.iddoca)
        if (this.$$_ordem.orcdoca) {
          if (!this.doca) {
            errorHandler('Faça a leitura de uma doca.')
            return;
          } else if (this.$$_validacaoDoca) {
            errorHandler('Esta doca não é permitida para este carregamento.')
            return;
          }
        }
        this.dialogInicio = false;
        this.$_clearHashRoute();
        const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
        const datainicio = geraData();
        await db.ordemcarregamento.update(this.$$_ordem.id, {
          orcdatainicio: datainicio,
          orcidusuarioiniciou: idusuario,
          orcdatanuvem: null,
        })
        this.$_reloadCache('ordemcarregamento');
        this.$_setarOrdem({
          ...this.$$_ordem,
          orcdatainicio: datainicio,
        })
        setTimeout(async () => {
          await this.$_abrirOrdem(ordem.orcidordemcarregamento);
          SetupEnvioLocal();
        }, 0);
        
        return;
      }
      this.dialogInicio = true;
      window.location.hash = '#iniciar'
      console.log('armazem', this.armazem)
    },

    async $_abrirOrdem(id) {
      
      const itens = this.$$_cacheItem.filter((i) => i.ociidordemcarregamento === id); 
      this.$_adicionarItens(itens)
      this.dialogVisivel = true;
      window.location.hash = '#itens'
      this.itemSelecionado = this.$$_ordem;
      this.loadingItens = true;
      try {
        this.itens = this.$$_itens;
        if (this.$$_itens.length > 0) this.selectedItemId = this.$$_itens[0].ociidordemcarregamentoitem;
      } catch (error) {
        errorHandler('Erro ao carregar os itens da O.C.: ' + error.message);
      } finally {
        this.loadingItens = false;
      }
      
      this.$_verificaCompleto(this.$$_itens);
    },

    async $_abrirUnidade(itemid) {
      console.log('unidade desse itemid', this.$$_cacheUnidade.filter((u) => (u.ocuidordemcarregamentoitem === itemid)));
      const unidades = this.$$_cacheUnidade.filter((u) => (u.ocuidordemcarregamentoitem === itemid && u.ocuorigem === 'D') || (u.ocuidordemcarregamentoitem === itemid && u.ocudatafinalizado));
      const unidadesInseridas = this.$$_cacheUnidade.filter((u) => {
        if (u.ocuidordemcarregamentoitem === itemid) console.log('unidade', u.ocudatacriacao);
        return u.ocuidordemcarregamentoitem === itemid && u.ocudatacriacao
      });
      console.log('inseridas',itemid, unidadesInseridas);
      // console.log('inseridas cache',this.$$_cacheUnidade);
      // await db.ordemcarregamentounidade.where({ocuidordemcarregamentoitem: itemid}).toArray()
      const item = this.$$_itens.find(i => i.ociidordemcarregamentoitem === itemid);
      console.log('UNIDADES', unidades);
      console.log('item abriu ordem', item);
      console.log('item que era atual', this.itemAtual);
      console.log(JSON.stringify(this.itemAtual) !== JSON.stringify(item));
      if (JSON.stringify(this.itemAtual) !== JSON.stringify(item)) {
        this.$_limparUnidades();
        this.$_limparUnidadesInseridas();
      }
      this.$_adicionarItemAtual(item);
      this.$_adicionarUnidades(unidades);
      this.$_adicionarUnidadesInseridas(unidadesInseridas);
      this.$router.push({
        ...this.$route,
        name: ROUTE_ORDEM_CARREGAMENTO_UNIDADE.name,
      });
    },

    async $_confirmarFinalizacao() {
      const itens = this.$$_cacheItem.filter((i) => i.ociidordemcarregamento === this.$$_ordem.orcidordemcarregamento); 
      this.$_adicionarItens(itens);
      this.enviando = true;
      try {
        const validacao = await Promise.all(this.$$_itens.map(async (item) => {
          const itemid = item.ociidordemcarregamentoitem;
          const unidades = this.$$_cacheUnidade.filter((u) => (u.ocuidordemcarregamentoitem === itemid && u.ocuorigem === 'D') || (u.ocuidordemcarregamentoitem === itemid && u.ocudatafinalizado));
          const unidadesInseridas = this.$$_cacheUnidade.filter((u) => u.ocuidordemcarregamentoitem === itemid && u.ocudatacriacao);
          return await this.validaItem({ ...item, inseridas: unidadesInseridas }, unidades, item.ociquantidade);
        }));

        const erro = validacao.filter((i) => i !== undefined && i.item.ociverificaunidade === 'S');
        if (erro.length > 0) {
          this.validacaoData = erro;
          this.validacaoFinalizar = true;
          this.validacaoTipo = 'erro';
          setTimeout(() => {
            window.location.hash = '#validacao';
          }, 0);
          return;
        }

        const alerta = validacao.filter((i) => i !== undefined && i.item.ociverificaunidade === 'N');
        if (alerta.length > 0) {
          this.validacaoData = alerta;
          this.validacaoFinalizar = true;
          this.validacaoTipo = 'alerta';
          setTimeout(() => {
            window.location.hash = '#validacao';
          }, 0);
          return;
        }

        await this.$_finalizarOrdem();
      } catch (e) {
        errorHandler(e, 'Falha ao finalizar Ordem de Carregamento');
      } finally {
        this.enviando = false;
        this.dialogFinalizar = false;
        this.$_clearHashRoute();
      }
    },

    async $_finalizarOrdem() {
      const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
      await db.ordemcarregamento.update(this.$$_ordem.id, {
        orcdatafinalizado: geraData(),
        orcidusuariofinalizou: idusuario,
        orcdatanuvem: null,
      })
      this.$_limparOrdem();
      this.$_reloadCache('ordemcarregamento');
      this.$_verificaCompleto(this.$$_itens);
      SetupEnvioLocal();
    },

    $_limitarTexto(texto, limite) {
      if (texto && texto.length > limite) return `${texto.substring(0, limite)}...`;
      return texto;
    },

    $_FormataDataGeral(date) {
      // console.log(date);
      return moment.utc(date).format('DD/MM/YYYY HH:mm');
    },
    
    $_onClickQR(tipo) {
      if (tipo === 'qrdoca') {
        console.log('ordem', this.$$_ordem)
        this.leituraDoca = true;
        sessionStorage.setItem('qrordem', this.$$_ordem.orcidordemcarregamento)
      }
      sessionStorage.setItem(tipo, 'true');
      sessionStorage.setItem('rota-anterior', ROUTE_ORDEM_CARREGAMENTO.path);
      this.$nextTick(() => {
        setTimeout(() => {
          this.$router.push({
            ...this.$route,
            name: ROUTE_QR.name,
          });
        }, 0);
      })
    },

    async $_verificaQR() {
      const qr = sessionStorage.getItem(OPLOCAL_STORAGE.qr);
      if (qr && qr.length && qr !== 'null') {
        console.log(qr, this.search);
        console.log(sessionStorage.getItem('qrordem'));
        console.log(sessionStorage.getItem('qrdoca'));
        this.$nextTick(() => {
          if (sessionStorage.getItem('qrordem') && sessionStorage.getItem('qrdoca')) {
            this.$refs.ordem.search = sessionStorage.getItem('qrordem');
            sessionStorage.removeItem('qrordem');
          } else {
            this.$refs.ordem.search = qr;
            sessionStorage.removeItem('qrordem');
            sessionStorage.removeItem(OPLOCAL_STORAGE.qr);
          }

        })
      }
      // sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
      // this.proximolote = JSON.parse(sessionStorage.getItem('lote'));
      // this.proximoembalagem= JSON.parse(sessionStorage.getItem('loteembalagem'));
    },

    $_validarDoca() {
      console.log('QR VINDOOO', sessionStorage.getItem(OPLOCAL_STORAGE.qr))
      const qr = sessionStorage.getItem(OPLOCAL_STORAGE.qr)
      if (!qr || qr === 'null') return;
      this.doca = sessionStorage.getItem(OPLOCAL_STORAGE.qr);
      this.$refs.doca.search = this.doca;
      sessionStorage.removeItem('qrdoca');
      sessionStorage.removeItem(OPLOCAL_STORAGE.qr);
      this.leituraDoca = false;
    },

    $_voltarInicio() {
      this.dialogInicio = false;
      this.iddoca = null;
      this.$refs.doca.search = null;
      this.$_clearHashRoute();
    },
    
    $_isEmpty(obj) {
     return !obj || Object.keys(obj).length === 0;
    },

    $_limparVuex() {
      this.$_limparItens();
      this.$_limparItemAtual();
      this.$_limparUnidades();
      this.$_limparUnidadesInseridas();
      this.$_limparOrdem();
      if (this.$refs?.ordem?.search) this.$refs.ordem.search = null;
    },

    async $_onClickCamera() {
      this.$router.push({
            ...this.$route,
            name: ROUTE_CAMERA.name,
            params: { tipo: 'ordemcarregamento', id: this.$$_ordem.orcidordemcarregamento }
          });
    },

    FormataQuantVirgula(valor) {
      // Peso sem decimais (trunca), com separador de milhar
      return Math.trunc(Number(valor) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
    },

    async validaItem(item, unidades, quantidade) {
      const resultadoUnidades = await this.$_verificaUnidades({
        inseridas: item.inseridas ?? [],
        unidades
      });

      const resultadoQuantidade = await this.$_verificaQuantidade({
        quantidade,
        inseridas: item.inseridas ?? []
      });
      console.log('resultado Unidades', resultadoUnidades)
      console.log('resultado Quantidade', resultadoQuantidade) 
      if (!resultadoUnidades.resultado || !resultadoQuantidade.resultado) return {
        item,
        resultadoUnidades,
        resultadoQuantidade,
      };
    },
    
    async $_clearHashRoute() {
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '',
      }).catch(() => {});
    },

    async $_abrirFinalizar() {
      this.dialogFinalizar = true;
      window.location.hash = '#finalizar';
    },

    async $_continuarFinalizar() {
      this.validacaoFinalizar = false;
      this.$_clearHashRoute();
      this.$_finalizarOrdem();
    },
  },


  async created() {
    SetupEnvioLocal();
    this.$_load();
    // }
    this.$_verificaQR();
  },

  beforeRouteLeave(to, from, next) {
    setTimeout(() => {
        if (this.$route?.hash) {
          if (this.$route?.hash === '#itens') this.dialogVisivel = false;
          if (this.$route?.hash === '#finalizar') this.dialogFinalizar = false;
          if (this.$route?.hash === '#validacao') this.validacaoFinalizar = false;
          if (this.$route?.hash === '#iniciar') {
            this.dialogInicio = false;
            next();
          }
      } else {    
        const rotasPermitidas = [
          ROUTE_ORDEM_CARREGAMENTO_UNIDADE.name,
          ROUTE_CAMERA.name,
          ROUTE_ORDEM_CARREGAMENTO.name,
        ];

        if (!rotasPermitidas.includes(to.name)) {
          this.$_limparVuex();
        }

        next();
      }
    }, 0);
  },
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      // Agora 'vm' é a instância do componente (equivalente ao 'this')
      if (vm.$$_itens.length > 0) {
        const itens = await db.ordemcarregamentoitem.where({
          ociidordemcarregamento: vm.$$_ordem.orcidordemcarregamento
        }).toArray();

        vm.$_adicionarItens(itens);
        vm.selectedItemId = vm.itemAtual.ociidordemcarregamentoitem;
        vm.itemSelecionado = vm.$$_ordem;
        vm.$_verificaCompleto(vm.$$_itens);
      }
      if (from.name === 'ordemcarregamentounidade') {
        vm.reexibirDialog = true;
      }

      if (from.name === 'qr' && sessionStorage.getItem('qrdoca')) {
        vm.leituraDoca = true;
      }

      if (vm.$_isEmpty(vm.$$_ordem)) {
        sessionStorage.removeItem('qrordem');
        sessionStorage.removeItem('qrdoca');
        sessionStorage.removeItem(OPLOCAL_STORAGE.qr);
      }
    });
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        if (this.$route?.hash) {
          if (this.$route?.hash === '#itens') this.dialogVisivel = true;
          if (this.$route?.hash === '#finalizar') this.dialogFinalizar = true;
          if (this.$route?.hash === '#validacao') this.validacaoFinalizar = true;
        } else {
          this.dialogVisivel = false;
          this.dialogFinalizar = false;
          this.validacaoFinalizar = false;
        }

        const filters = {
          createdFrom: getQueryValue(ABASTECIMENTO_QUERIES.createdFrom, this.filters.createdFrom),
          createdBefore: getQueryValue(
            ABASTECIMENTO_QUERIES.createdBefore,
            this.filters.createdBefore,
          ),
        };

        if (!deepEquals(this.filters, filters)) {
          this.filters.createdFrom = filters.createdFrom;
          this.filters.createdBefore = filters.createdBefore;

          if (this.$refs.lista) {
            this.$_load();   
          }
        }
      },
    },

    options: {
      deep: true,
      handler() {
        // setQueryValue(ABASTECIMENTO_QUERIES.createdFrom, this.filters.createdFrom);
        // setQueryValue(ABASTECIMENTO_QUERIES.createdBefore, this.filters.createdBefore);
      },
    },

    $$_ordem: {
      deep: true,
      immediate: true,
      handler() {
        console.log('ordem watch', this.$_isEmpty(this.$$_ordem))
        if (this.$_isEmpty(this.itemAtual)) this.$_limparItens();
      }
    },

    $$_loading: {
      deep: true,
      async handler() {
        if (!this.$$_loading && this.reexibirDialog) {
          this.dialogVisivel = true;
          window.location.hash = '#itens'
          this.reexibirDialog = false;
      }
       if (this.leituraDoca && !this.$$_loading) {
        console.log('tá vindo da doca', sessionStorage.getItem(OPLOCAL_STORAGE.qr))
        this.dialogInicio = true;
        this.$nextTick(() => {
          this.$_validarDoca();
        })
      }
      }
    },
  },
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }
  
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 400px;
  }

  .card-wrapper {
    display: flex;
    margin: 0px;
  }

  .icon {
    height: 70px;
  }

  .linha-aberto {
    background-color: #4CAF50;
    color: white;
  }

  .linha-fechado {
    background-color: #c0372e;
    color: white;
  }

  .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .card-secador {
    width: 40vw;
    text-align: center;
    margin: 10px;
  }

  .numero {
    font-size: 22px;
  }

  .card {
    width:  100%;
    text-align: center;
    margin: 10px;
    margin-bottom: 0;
  }

  .card_title {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 0.9em;
    padding: 0.2em !important;
    height: fit-content;
    background-color: #4CAF50;
    color: white;
  }

  .card_detalhes {
    display: block;
    text-align: left;
  }

  .card_detalhes span:nth-of-type(odd) {
   background-color: #f5f5f5; 
  }

  .card_detalhes span:nth-of-type(even) {
    background-color: #e0e0e0; 
  }

  .n-center >>> input {
      margin: 0;
  }
  .textfield {
    width: 90%;
    height: 56px !important
  }


/* DIALOG */
.card-all {
  border-radius: 10px;
  max-width: 900px;
}
.table-custom {
  width: 100%;
  border-collapse: collapse;
  min-width: 100%;
}
.table-header th {
  color: white;
  padding: 6px;
  text-align: left;
  font-weight: bold;
  border-bottom: 2px solid #ddd;
  background-color: #4CAF50;
  position: sticky;
  top: 0;
  z-index: 2;
}
.table-header-card th {
  color: black;
  background-color: white;
  padding: 2px;
  text-align: left;
  font-weight: bold;
  border-bottom: 2px solid #ddd;
  position: sticky;
  top: 0;
  z-index: 2;
}
.table-row-fist{
  font-size: 14px;
  padding: 10px 12px;
  border-top: 1px solid #eee;
  vertical-align: middle;
}
.table-row td {
  font-size: 14px;
  padding: 10px 12px;
  border-top: 1px solid #eee;
  vertical-align: middle;
}
.table-row.dark-background {
  background-color: #bbb5b521;
}
.linha-alternada td{
  background-color: #bbb5b521;
}
.v-dialog .table-row:not(tfoot tr) td:first-child {
  text-align: center;
}
.v-radio {
  display: inline-block;
}
.table-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.linha-selecionada td{
  background-color: #E8F5E9 !important;
  color: #2E7D32;
  font-weight: 500;
}

.linha-finalizada td{
  background-color: #fdffd2 !important;
  color: #2E7D32;
  font-weight: 500;
}

.coluna-descricao {
  text-align: start !important;
  white-space: nowrap;
}
/deep/ .simplebar-scrollbar::before {
  background-color: #4CAF50 !important;
}
/deep/ .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}
.cardtitle{
  font-size: 17px;
}
.table-scroll-container {
  max-height: 70vh;
}
.table-scroll-container-card {
  max-height: 50vh;
}

.botoes {
  display: flex;
  justify-content: start !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
  width: 100%;
}

.botoes > * {
  flex: 1;  
}

.detalhe-placa {
  max-height: 24px;
}
</style>
